import { render, staticRenderFns } from "./TaskDeleteDialog.vue?vue&type=template&id=deb05c48"
import script from "./TaskDeleteDialog.vue?vue&type=script&lang=js"
export * from "./TaskDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports